import * as yup from 'yup';

export const serviceValidationSchema = yup.object({
    isActive: yup.boolean(),
    name: yup.string().required('Nazwa jest wymagana'),
    basePrice: yup.number().required('Cena jest wymagana').min(0, 'Cena musi być większa lub równa 0'),
    category: yup.string().required('Kategoria jest wymagana'),
    subservices: yup.string(),
    isGraphical: yup.boolean(),
    questionsJson: yup.string(), // Keep as string
    questions: yup.array().of(  // Add validation for the array
        yup.object().shape({
            id: yup.string().required(),
            text: yup.string(),
            options: yup.array().of(yup.string()),
            correctOptionIndex: yup.number()
        })
    )
});